import React, { useCallback, useMemo, useRef } from 'react';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import { TreeView } from '../../../../../common/components/layout';
import { MapGeometryExact } from '../../../../../map/models/MapGeometry';

const FlightPathTreeView = ({ flightPath, setFlightPath, setCenteredGeometries, disabled }) => {
  const handleFlightPathCenterClick = useCallback(() => {
    setCenteredGeometries([flightPath]);
  }, [flightPath, setCenteredGeometries]);

  const handleFlightPathVisibilityClick = useCallback(
    (_, isToggled) => {
      setFlightPath({ ...flightPath, visible: !isToggled });
    },
    [flightPath, setFlightPath]
  );

  const { current: flightPathItemActions } = useRef([
    { id: 'flightPath-center', icons: { default: 'gps_fixed' }, onClick: handleFlightPathCenterClick },
    {
      id: 'flightPath-visibility',
      icons: { default: 'visibility', toggled: 'visibility_off' },
      onClick: handleFlightPathVisibilityClick,
    },
  ]);

  const flightPathItem = useMemo(
    () => [
      {
        id: 'root',
        label: i18n.t('patrol.details.flightPath'),
        actions: flightPathItemActions,
        disabled,
      },
    ],
    [disabled, flightPathItemActions]
  );

  return <TreeView id="flightPath" items={flightPathItem} />;
};

FlightPathTreeView.propTypes = {
  flightPath: MapGeometryExact,
  setFlightPath: PropTypes.func.isRequired,
  setCenteredGeometries: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

FlightPathTreeView.defaultProps = {
  flightPath: {},
  disabled: false,
};

export default FlightPathTreeView;
